export default {"src":"/_next/static/media/close-dark.d77c97d1.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};